import React from "react";
import ColumnFilters, { FilterField, FilterTag } from "./ColumnFilters";

interface TicketsFilterProps {
  filterTags: FilterTag[];
  onAddFilter: (field: FilterField, value: string) => void;
  onRemoveFilter: (id: string) => void;
  onClearAllFilters: () => void;
}

const TicketsFilter: React.FC<TicketsFilterProps> = ({
  filterTags,
  onAddFilter,
  onRemoveFilter,
  onClearAllFilters,
}) => {
  return (
    <ColumnFilters
      filterTags={filterTags}
      onAddFilter={onAddFilter}
      onRemoveFilter={onRemoveFilter}
      onClearAllFilters={onClearAllFilters}
    />
  );
};

export default TicketsFilter;